import Pagination from './base/pagination'
// import CircleProgress from './base/circleProgress '
// import EChart from './eChart/chart'
// import Tabs from './tabs/index'
// import IframeView from './iframeView/index'
// import LineProgress from './base/lineProgress'
// import YrButton from './button/button'
// import Network from './dialog/networkError'
function plugin (Vue) {
  if (plugin.installed) return
  Vue.component('page-box', Pagination)
  // Vue.component('circle-progress', CircleProgress)
  // Vue.component('e-chart', EChart)
  // Vue.component('Tabs', Tabs)
  // Vue.component('iframe-view', IframeView)
  // Vue.component('line-progress', LineProgress)
  // Vue.component('yr-button', YrButton)
  // Vue.component('network', Network)
}

export default plugin
